module.exports = __webpack_public_path__ + "media/common/interview-feature3@2x-585e4eb8.png";